var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatBoldi = function SvgChatBoldi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12.3 16H9.415A.42.42 0 0 1 9 15.582V8.418A.42.42 0 0 1 9.415 8h2.357a1.974 1.974 0 0 1 1.457 3.284A2.454 2.454 0 0 1 12.3 16m-2.471-.836H12.3a1.612 1.612 0 0 0 0-3.224H9.829zm0-4.048h1.943a1.135 1.135 0 0 0 0-2.269H9.829z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatBoldi);
export default ForwardRef;